import { render, staticRenderFns } from "./BodyguardPrice.vue?vue&type=template&id=0d8de169&"
import script from "./BodyguardPrice.vue?vue&type=script&lang=js&"
export * from "./BodyguardPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports